import formAPImypatients from "./mypatient";


var formattedOutput = null;

const formAPIModelmypatients = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPImypatients(item));


  return formattedOutput
};

export default formAPIModelmypatients